import { yupResolver } from '@hookform/resolvers/yup'
import { Auth } from 'aws-amplify'
import Router from 'next/router'
import { NextSeo } from 'next-seo'
import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { object, string } from 'yup'

import AuthBg from '@/assets/illustrations/auth.svg'
import Button, { ButtonVariant } from '@/components/button'
import Input from '@/components/input'
import Link from '@/components/link'
import getQueryParam from '@/utils/get-query-param'
import handleApiError from '@/utils/handle-api-error'
import protectedRoute from '@/utils/protected-route'

const schema = object({
  email: string().email().required(),
  password: string().min(8).required(),
}).required()

const Login = () => {
  const defaultEmail = getQueryParam('email') || ''

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { email: defaultEmail, password: '' },
  })

  const onSubmit = useCallback(
    ({ email, password }) =>
      Auth.signIn(email, password).catch(handleApiError).then(Router.back()),
    [],
  )

  return (
    <div className='flex h-[100%] min-h-full flex-wrap items-end self-end bg-theme-turquoise px-5'>
      <NextSeo title='Login' />
      <div className='py-custom flex-[0_0_100%] px-16'>
        <div className='flex justify-end self-center'>
          {/* <div>
            <Button
              variant={ButtonVariant.Primary}
              bg='bg-[#234370]'
              tailFill='#234370'
              className='cm-bg !px-2 py-0.5 text-white'
              tailClassName='right-[unset] left-0 scale-x-[-1] -translate-x-[50%] translate-y-[41%] h-2'
            >
              <span className='translate-y-0.5'>SIGN IN</span>
            </Button>
          </div>
          <div>
            <Link href='/auth/register' className='font-custom text-[#E2846F]'>
              <span className='signUp-button'>Sign up</span>
            </Link>
          </div> */}
          <Button
            type='submit'
            variant={ButtonVariant.Primary}
            bg='bg-[#234370]'
            tailFill='#234370'
            className='w-fit rounded-3xl !px-5 py-1.5 uppercase !text-white'
            tailClassName='right-[unset] left-0 scale-x-[-1] -translate-x-[50%] translate-y-[40%]'
          >
            <Link href='/auth/register'>
              <span className='signUp-button'>Sign up</span>
            </Link>
          </Button>
        </div>

        <div className='relative'>
          <div className='py-4'>
            <form
              className='auth-form flex flex-col items-end space-y-2'
              onSubmit={handleSubmit(onSubmit)}
            >
              <Input
                name='email'
                label='Email'
                type='email'
                autoComplete='email'
                required
                register={register}
                errors={errors}
              />

              <Input
                name='password'
                type='password'
                label='Password'
                autoComplete='current-password'
                required
                register={register}
                errors={errors}
              />

              <div className='flex w-full items-center justify-between pt-2'>
                <div className='text-sm'>
                  <Link
                    href='/auth/forgot-password'
                    className='custom-font22 text-[#E2846F]'
                  >
                    Forgot &nbsp;password?
                  </Link>
                </div>
                <Button
                  type='submit'
                  variant={ButtonVariant.Primary}
                  bg='bg-white'
                  tailFill='white'
                  className='custom-font22 w-fit rounded-3xl !px-5 py-1.5'
                  tailClassName='right-[unset] left-0 scale-x-[-1] -translate-x-[50%] translate-y-[40%]'
                >
                  Log In
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='flex-[0_0_100%] self-end'>
        <img src={`${AuthBg.src}`} className='mx-auto' />
      </div>
      <style jsx>
        {`
          .signUp-button {
            font-family: 'Overpass';
            font-weight: 400;
            font-size: 25pt;
            line-height: 30pt;
          }
          .py-custom {
            max-width: 524px;
            margin: 200px auto 20px;
          }
          form.auth-form {
            margin-top: 50px;
          }
          @media (max-width: 1920px) {
            .py-custom {
              max-width: calc(
                320px + (524 - 320) * (100vw - 375px) / (1920 - 375)
              );
              margin: calc(115px + (200 - 115) * (100vw - 375px) / (1920 - 375))
                auto 20px;
            }
            .signUp-button {
              font-size: calc(8pt + (25 - 12) * (100vw - 281pt) / (1920 - 375));
              line-height: calc(
                10pt + (30 - 15) * (100vw - 281pt) / (1920 - 375)
              );
            }
          }
        `}
      </style>
    </div>
  )
}

export default protectedRoute(Login, { preventLoggedInUsers: true })
